<template>
  <div>
    <DrawerContainer
      :dialogShow="dialogShow"
      :dialog-width="'80%'"
      title="订单改派"
      :hasFooter="false"
      @resetPopupData="dialogShow = false">
      <div class="order-detail custom-form">
        <div class="table-list">
          <div class="list-content-left">
            <div class="list-top">
              <div class="list-top-left">
                <div class="left-box" v-for="(item2, index) in detail.pointList" :key="index">
                  <div class="left-box-top">
                    <div class="label" :class="item2.loadType === 1 ? 'zhuang' : 'xie'">
                      {{ item2.loadType === 1 ? "装" : "卸" }}
                    </div>
                    <div class="name">{{ item2.cityName }}{{ item2.districtName }}</div>
                  </div>
                  <div class="">
                    <div>{{ item2.address }}</div>
<!--                    <div>{{ item2.endTime }}</div>-->
                  </div>
                </div>
              </div>
              <div class="list-top-right">
                <div class="right-box2">
                  <div class="right-box2-time">
                    <span>装货时间：{{ detail.startLoadTime }}</span>&nbsp;
                    &nbsp;
                    <span>下单时间：{{ detail.createTime }}</span>
                    &nbsp;
                    <span>货主姓名：{{ detail.ownerName }}</span>
                    &nbsp;
                    <span>货主电话：{{ detail.ownerPhone }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="list-bottom">
              <div class="list-bottom-box">
                <div class="bottom-box-name">物品</div>
                <div class="bottom-box-value">
                  {{ detail.cargo.cargoName || "-" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">重量</div>
                <div class="bottom-box-value">
                  {{ detail.cargo.weight || "-" }}
                  {{ detail.cargo.wightUnit === 1 ? "吨" : "公斤" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">体积</div>
                <div class="bottom-box-value">{{ detail.cargo.volume || "-" }}㎡</div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">包装方式</div>
                <div class="bottom-box-value">
                  {{ detail.cargo.packingWays || "-" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">用车要求</div>
                <div class="bottom-box-value">
                  {{ detail.vehicleUseType || "-" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">车型</div>
                <div class="bottom-box-value">
                  <custom-tooltip-multiple :text="detail.vehicle?.vehicleMode"></custom-tooltip-multiple>
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">车长</div>
                <div class="bottom-box-value">
                  <custom-tooltip-multiple :text="detail.vehicle?.vehicleLength"></custom-tooltip-multiple>
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">运费</div>
                <div class="bottom-box-value">
                  <span class="money">{{ detail.driverFee || "-" }}</span>
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">承运车牌</div>
                <div class="bottom-box-value">
                  {{ detail?.driver.carNumber || "-" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">司机</div>
                <div class="bottom-box-value">
                  {{ detail?.driver.username || "-" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">司机电话</div>
                <div class="bottom-box-value">
                  {{ detail?.driver.phone || "-" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="search-form-box">
          <el-row :gutter="30">
            <el-form inline>
              <el-col :span="8">
                <el-form-item label="司机电话:">
                  <el-input
                    style="width: 100%"
                    clearable
                    v-model="searchForm.keyword"
                    autocomplete="off"
                    placeholder="请输入司机姓名/手机号码" />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="">
                  <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                  <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
        <div class="table-box-reassignment">
          <custom-table
            :data="tableData"
            :column="tableColumn"
            :total="tableOptions.total"
            :loading="tableOptions.loading"
            :page="tableOptions.pageNumber"
            :size="tableOptions.pageSize"
            :selection="false"
            @pagination="handleSizeChange">
            <template v-slot:marginVolume="{ row }">{{ row.marginWeight }}t/{{ row.marginVolume }}m³</template>

            <template v-slot:startCityName="{ row }">{{ row.startCityName }}-{{ row.endCityName }}</template>
            <template v-slot:reportStatus="{ row }">
              <div class="operate">
                <span class="common-status status-pending-order" v-if="row.reportStatus === 0">未上报</span>
                <span class="common-status status-confirm" v-if="row.reportStatus === 1">接单中</span>
                <span class="common-status status-in-progress" v-if="row.reportStatus === 2">配满发车</span>
<!--                <span class="common-status status-error" v-if="row.reportStatus === 3">休息中</span>-->
              </div>
            </template>
            <template v-slot:operation="{ row }">
              <span class="operate-btn" @click="handleDaoHang(row)">导航测算</span>
              <span class="operate-btn" @click="handleGaiPai(row)">改派</span>
            </template>
          </custom-table>
        </div>
      </div>
    </DrawerContainer>
    <reassignmentReason ref="reassignmentReason"></reassignmentReason>
    <navigationCalculation ref="navigationCalculation"></navigationCalculation>
  </div>
</template>
<script>
import DrawerContainer from "@/components/Drawer.vue";
import CustomTable from "@/components/CustomTable.vue";
import tableMixin from "@/mixin/tableMixin";
import CustomDateRange from "@/components/CustomDateRange.vue";
import { detailInfo } from "./api";
import { getDispatchDriver } from "@/views/commonApi";
import CustomTooltip from "@/components/CustomTooltip.vue";
import CustomTooltipMultiple from "@/components/CustomTooltipMultiple.vue";
import reassignmentReason from "./reassignmentReason.vue";
import navigationCalculation from "../../SchedulingWorkbench/OrderScheduling/navigationCalculation.vue";
export default {
  name: "AddOrEdit",
  mixins: [tableMixin],
  data() {
    return {
      detail: {},
      orderId: "",
      getTableMethod: getDispatchDriver,
      loading: false,
      dialogShow: false,
      tableColumn: [
        {
          label: "司机姓名",
          prop: "username",
          align: "left",
          show: true,
        },
        {
          label: "车牌号码",
          prop: "carNumber",
          align: "left",
          show: true,
        },
        {
          label: "手机号",
          prop: "phone",
          align: "left",
          show: true,
        },
        {
          label: "车型",
          prop: "vehicleMode",
          align: "left",
          show: true,
        },
        {
          label: "车长",
          prop: "vehicleLength",
          align: "left",
          show: true,
        },
        {
          label: "上报状态",
          prop: "reportStatus",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "剩余容量",
          prop: "marginVolume",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "线路",
          prop: "startCityName",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "当前订单数",
          prop: "currentOrder",
          align: "left",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "150px",
          scopeStatus: true,
          show: true,
        },
      ],
      searchForm: {
        keyword: "",
      },
    };
  },
  components: {
    CustomTooltip,
    CustomTooltipMultiple,
    CustomDateRange,
    reassignmentReason,
    navigationCalculation,
    CustomTable,
    DrawerContainer,
  },
  methods: {

    resetTable() {
      this.$parent.handleAddOrEditSuccess("edit");
      this.dialogShow = false;
    },
    getOrderDetail(orderId) {
      detailInfo(orderId).then((res) => {
        if (res.code === 200) {
          this.detail = res.data;
        }
      });
    },
    init(row) {
      this.orderId = row.orderId;
      this.getOrderDetail(row.orderId);
      this.dialogShow = true;
    },
    handleDaoHang(row) {
      this.$refs.navigationCalculation.init({
        order: this.detail,
        driver: row,
      })
    },
    handleGaiPai(row) {
      this.$refs.reassignmentReason.init(this.orderId, row.driverId);
    },
  },
};
</script>

<style scoped lang="scss">
.order-detail {
  .table-list {
    width: 100%;
    background: #fbfcff;
    margin-bottom: 0.2rem;
    padding: 0.12rem 0.1rem;
    box-sizing: border-box;
    border: 0.01rem solid #fbfcff;
    border-radius: 0.08rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    .list-content-left {
      flex: 1;
    }
    .list-content-right {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      padding-top: 0.1rem;
      box-sizing: border-box;
      padding-left: 0.2rem;
      .right-default {
        width: 0.64rem;
        height: 0.21rem;
        border-radius: 0.04rem;
        background-color: #eaf1ff;
        color: #1269ff;
        font-size: 0.12rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.1rem;
      }
      .right-primary {
        width: 0.64rem;
        height: 0.21rem;
        border-radius: 0.04rem;
        background-color: #1269ff;
        color: #ffffff;
        font-size: 0.12rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .list-top {
      display: flex;
      justify-content: space-between;
      .list-top-left {
        display: flex;
        .left-box {
          padding-right: 0.5rem;
          position: relative;
          .left-box-top {
            display: flex;
            align-items: center;
            .label {
              width: 0.2rem;
              height: 0.2rem;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 0.02rem;
              font-size: 0.12rem;
            }
            .zhuang {
              color: #5cc41a;
              background-color: rgba(92, 196, 26, 0.3);
            }
            .xie {
              color: #e52019;
              background-color: rgba(229, 32, 25, 0.3);
            }
            .name {
              color: #000000;
              font-size: 0.18rem;
              line-height: 0.2rem;
              padding-left: 0.04rem;
            }
          }
          .date {
            color: #8c8c8c;
            font-size: 0.12rem;
            line-height: 0.2rem;
          }
        }
        .left-box::before {
          content: "→";
          position: absolute;
          right: 0.15rem;
          top: 0.04rem;
          color: #52c41a;
        }
        .left-box:nth-last-of-type(1)::before {
          display: none;
        }
      }
      .list-top-right {
        .right-money {
          display: flex;
          justify-content: right;
          align-items: baseline;
          color: #faad14;

          .unit {
            font-size: 0.12rem;
            padding-left: 0.04rem;
          }
        }
        .right-box2 {
          display: flex;
          align-items: center;
          .right-box2-time {
            font-size: 0.12rem;
            line-height: 0.2rem;
            color: #8c8c8c;
            margin-right: 0.1rem;
          }
          .right-box2-label {
            background-color: #fff7e6;
            color: #fa8c16;
            font-size: 0.12rem;
            line-height: 0.22rem;
            border-radius: 0.1rem;
            padding: 0 0.1rem;
          }
        }
      }
    }
    .list-bottom {
      width: 100%;
      display: flex;
      padding: 0.12rem 0;
      .list-bottom-box {
        width: 15%;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        .bottom-box-name {
          color: #8c8c8c;
          font-size: 0.12rem;
          margin-bottom: 0.1rem;
        }
        .bottom-box-value {
          color: #434343;
          font-size: 0.14rem;
          text-align: center;
        }
      }
      .list-bottom-box::before {
        content: "";
        position: absolute;
        right: 0;
        top: 0.08rem;
        width: 0.01rem;
        height: 0.26rem;
        background-color: #dce5f5;
      }
      .list-bottom-box:nth-last-of-type(1)::before {
        display: none;
      }
    }
    .car-box {
      display: flex;
      align-items: center;
      border-top: 0.01rem dashed #dce5f5;
      padding: 0.1rem 0 0;
      .list-1 {
        display: flex;
        align-items: center;

        .label-img {
          width: 0.14rem;
          height: 0.14rem;
        }
        .center-name {
          line-height: 0.2rem;
          padding-left: 0.04rem;
          font-size: 0.14rem;
          color: #52c41a;
        }
      }
      .list-2,
      .list-3 {
        font-size: 0.12rem;
        color: #8c8c8c;
      }
      .list-2 {
        padding: 0 0.2rem;
        position: relative;
        &::before {
          content: "";
          width: 0.01rem;
          height: 0.1rem;
          background-color: #dce5f5;
          position: absolute;
          left: 0.1rem;
        }
        &::after {
          content: "";
          width: 0.01rem;
          height: 0.1rem;
          background-color: #dce5f5;
          position: absolute;
          right: 0.1rem;
        }
      }
    }
  }
  .table-box-reassignment {
  }
}
</style>
